"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingUpdateTransport = exports.PricingCreateTransport = exports.PricingTransport = exports.ServiceAreaMutate = exports.ServiceAreaTransport = exports.PricingGrowthStage = exports.PricingDataDailyAvailibity = exports.ZoneTypeLabelSAP = exports.ZoneType = exports.PricingTypes = exports.PricingType = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const ca_state_1 = require("./ca-state");
const pricing_data_transport_1 = require("./pricing-data-transport");
const sales_tax_1 = require("./sales-tax");
const service_area_envelope_1 = require("./service-area-envelope");
const us_state_1 = require("./us-state");
var PricingType;
(function (PricingType) {
    PricingType["SOURGUM_INTERNAL"] = "SOURGUM_INTERNAL";
    PricingType["HAULER_BILLING"] = "HAULER_BILLING";
    PricingType["PUBLIC"] = "PUBLIC";
})(PricingType || (exports.PricingType = PricingType = {}));
exports.PricingTypes = ['SOURGUM_INTERNAL', 'HAULER_BILLING', 'PUBLIC'];
exports.ZoneType = typebox_1.Type.Union(exports.PricingTypes.map((type) => typebox_1.Type.Literal(type)));
exports.ZoneTypeLabelSAP = {
    HAULER_BILLING: 'Hauler Public',
    SOURGUM_INTERNAL: 'Sourgum Internal',
    PUBLIC: 'Sourgum Public',
};
exports.PricingDataDailyAvailibity = typebox_1.Type.Union([
    typebox_1.Type.Literal('OPEN'),
    typebox_1.Type.Literal('CLOSED'),
    typebox_1.Type.Literal('LIMITED'),
    typebox_1.Type.Literal('UNKNOWN'),
]);
exports.PricingGrowthStage = typebox_1.Type.Union([typebox_1.Type.Literal('SEED'), typebox_1.Type.Literal('GROWTH'), typebox_1.Type.Literal('MATURE')]);
exports.ServiceAreaTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    boundary: service_area_envelope_1.ServiceAreaEnvelope,
    areaName: typebox_1.Type.Optional(typebox_1.Type.String()),
    taxJurisdiction: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.ServiceAreaMutate = typebox_1.Type.Object({
    serviceArea: typebox_1.Type.Optional(typebox_1.Type.String()),
    boundary: typebox_1.Type.Optional(typebox_1.Type.String()),
    boundaryFormat: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Literal('KML'), typebox_1.Type.Literal('GEOJSON')])),
    areaName: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    taxJurisdiction: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
});
exports.PricingTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    serviceAreas: typebox_1.Type.Array(exports.ServiceAreaTransport),
    haulerID: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    haulerName: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    notes: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    pricingData: typebox_1.Type.Array(pricing_data_transport_1.MaterialPricingTransport),
    prohibitedItems: typebox_1.Type.Array(typebox_1.Type.String()),
    /**
     * @deprecated use type instead
     */
    public: typebox_1.Type.Boolean(),
    type: exports.ZoneType,
    state: typebox_1.Type.Union([us_state_1.UsStateAbbreviation, ca_state_1.CAProvinceAbbreviation]),
    tripCharge: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Number())),
    tripChargeDollars: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Number())),
    days: typebox_1.Type.Object({
        mon: exports.PricingDataDailyAvailibity,
        tue: exports.PricingDataDailyAvailibity,
        wed: exports.PricingDataDailyAvailibity,
        thu: exports.PricingDataDailyAvailibity,
        fri: exports.PricingDataDailyAvailibity,
        sat: exports.PricingDataDailyAvailibity,
        sun: exports.PricingDataDailyAvailibity,
    }),
    rentalPeriod: typebox_1.Type.Optional(typebox_1.Type.Object({
        value: typebox_1.Type.Number(),
        unit: typebox_1.Type.String(),
    })),
    rentExtensionFee: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Number())),
    rentExtensionFeeDollars: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Number())),
    zoneName: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    pricingCalculationVersion: typebox_1.Type.Optional(typebox_1.Type.String()),
    maxRentalDaysAllowed: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    prePaidRentalDaysDiscountRate: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    allowForPrePaidRentalDays: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    onlineCheckoutPageGuarantee: typebox_1.Type.Optional(typebox_1.Type.String()),
    currentGrowthStage: typebox_1.Type.Optional(exports.PricingGrowthStage),
    metro: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
    haulerApproved: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    sourgumApproved: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    actualTaxRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
    taxRateBreakdown: typebox_1.Type.Optional(sales_tax_1.TaxRateBreakDown),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.PricingCreateTransport = typebox_1.Type.Omit(exports.PricingTransport, [
    'id',
    'serviceAreas',
    'actualTaxRate',
    'metadata',
    'type',
]);
exports.PricingUpdateTransport = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.PricingTransport, ['serviceAreas', 'actualTaxRate', 'metadata', 'type', 'taxRateBreakdown']));
//# sourceMappingURL=pricing-transport.js.map